// extracted by mini-css-extract-plugin
module.exports = {"root":"mL-03","heading":"_3_gok"};